/**
 * Site-wide SEO constants. Change the host here and everywhere (canonical,
 * hreflang, Open Graph, sitemap, JSON-LD) follows.
 *
 * CommonJS so that the Node build scripts can require it too.
 *
 * Canonical host is `www`: the apex domain does not currently resolve, so every
 * absolute URL we publish must use www to avoid canonicalising to a dead host.
 */

var SITE_URL = 'https://www.e-comienza.com';

var SITE_NAME = 'E-comienza';

/** Default social/preview card. 1200x630. */
var DEFAULT_OG_IMAGE = '/og-image.png';
var OG_IMAGE_WIDTH = 1200;
var OG_IMAGE_HEIGHT = 630;

/** Logo used in structured data (must be an absolute URL when emitted). */
var LOGO_PATH = '/ecomienza-logo.png';

/** Contact details already published on the site. */
var CONTACT_EMAIL = 'info@e-comienza.com';
var CONTACT_WHATSAPP = '+1-954-470-8414';

/** Open Graph locales per app language. */
var OG_LOCALES = {
  en: 'en_US',
  es: 'es_419',
};

/** Build an absolute URL from a site-relative path. */
function absoluteUrl(path) {
  if (!path) return SITE_URL + '/';
  if (/^https?:\/\//i.test(path)) return path;
  return SITE_URL + (path.charAt(0) === '/' ? path : '/' + path);
}

module.exports = {
  SITE_URL: SITE_URL,
  SITE_NAME: SITE_NAME,
  DEFAULT_OG_IMAGE: DEFAULT_OG_IMAGE,
  OG_IMAGE_WIDTH: OG_IMAGE_WIDTH,
  OG_IMAGE_HEIGHT: OG_IMAGE_HEIGHT,
  LOGO_PATH: LOGO_PATH,
  CONTACT_EMAIL: CONTACT_EMAIL,
  CONTACT_WHATSAPP: CONTACT_WHATSAPP,
  OG_LOCALES: OG_LOCALES,
  absoluteUrl: absoluteUrl,
};
